/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const it_search_preview_content_see_all = /** @type {(inputs: {}) => string} */ () => {
	return `Vedi tutti i risultati`
};

const en_search_preview_content_see_all = /** @type {(inputs: {}) => string} */ () => {
	return `See all results`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "it" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const search_preview_content_see_all = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_preview_content_see_all(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search_preview_content_see_all", locale)
	if (locale === "it") return it_search_preview_content_see_all(inputs)
	return en_search_preview_content_see_all(inputs)
};
export { search_preview_content_see_all as "search-preview-content.see-all" }